<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-12 col-md-6">
        <app-breadcrumb
          page-title="Historicos y Auditoría"
          :directory="subTitle"
          :icon="'trello'"
        />
      </div>

      <div class="col-md-12">
        <app-tab :tabs="tabs" type="horizontal" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accAppId: String,
  },
  data() {
    return {
      tabs: [
        {
          icon: "briefcase",
          name: "Historicos",
          component: "historical-table",
          permission: "",
        },
        {
          icon: "activity",
          name: "Auditoría",
          component: "audit-table",
          permission: "",
        },
      ],
    };
  },
  computed: {
    accApp() {
      return this.$store.state.common.accApp;
    },
    subTitle() {
      return this.accApp != null
        ? `${this.accApp.accreditation_area.name} - ${this.accApp.accreditation_activity.name} - ${this.accApp.accreditation_type.name}`
        : "";
    },
  },
  created() {
    this.$store.state.common.accAppId = this.accAppId;
  },
  methods: {
    returnPage() {
      window.location.href = "/historical";
    },
  },
};
</script>